// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1mlSP","sendOtp":"AuthorizeToLogin_sendOtp__2eoa0"};